import CodeLoginTypeList from "./pages/ListPage.vue";
import CodeLoginTypeDetail from "./pages/FormPage.vue";
import CodeLoginTypeIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/code_login_type",
    component: CodeLoginTypeIndex,
    redirect: "/code_login_type/list",
    name: "code_login_type",
    children: [
      {
        path: "list",
        component: CodeLoginTypeList,
        name: "code_login_type.list",
      },
      {
        path: "create",
        component: CodeLoginTypeDetail,
        name: "code_login_type.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: CodeLoginTypeDetail,
        name: "code_login_type.edit",
        props: { create: false },
      },
    ],
  },
];
